import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ServicerequestService,EquipmentService,TicketsService } from 'src/app/services';
import { Table } from 'primeng/table';
import { DashBoardServiceRequest, UserDetail, AccessUserInfo, UserFacility, UserLocationFacility } from 'src/app/models';
import {FacilityService} from 'src/app/services';
import { DatePipe } from '@angular/common';



@Component({
  selector: 'bart-service-request',
  templateUrl: './service-request.component.html',
  styleUrls: ['./service-request.component.scss']
})
export class ServiceRequestComponent implements OnInit {
  datePiepe = new DatePipe('en-US')
  loading: boolean=false;
  ServiceRequestcols: any[];
  etcols: any[];
  tpcols:any[];
  public USERID: number;
  @Input() userFacilityList;
  voidServiceRequestReason = '';                  
  ServiceRequestMangerData: DashBoardServiceRequest[]=[];
  equipmenttickets=[];
  getTicketPartsData=[];
  getServiceRequestTicket=[];
  displayServiceRequestDetails:boolean=false;
  displaySRConfirm: boolean = false;     
  displaySRTicketConfirm: boolean = false;  
  displaySRTicketDetail: boolean = false;    
  voidSRTicketSuccess: boolean = false; 
  setSRTicketSuccess: boolean = false;      
  public selectedData: any;
  public selectedServiceRequestTicket:any;
  public txtkeywordNg: string='';
  public userFacilityIdList:any;
  public userInfo :UserDetail;
  Loding: boolean = false;

  @ViewChild('dt', {static: false}) tableRefdt: Table;
  @ViewChild('dtet', {static: false}) tableRefdtet: Table;
  @ViewChild('dttp', {static: false}) tableRefdttp: Table;

  constructor(private _getServiceRequest:ServicerequestService, private _getEquipmentTickets:EquipmentService, 
    private _getTicketsService:TicketsService, private _setServiceRequestTicket:ServicerequestService ,
    private facilityService:FacilityService) { }

  ngOnInit() {
    this.userFacilityIdList=this.facilityService.getCurrentUserFacilityMasterIdList()
    this.userInfo=AccessUserInfo.getUserInfo()
    //this.getServiceRequest();//Commented By Harikesh on 08-Sep-2020
    //Start:Added By Harikesh on 08-Sep-2020 for Defect#12154
     if(this.userFacilityIdList!=null && this.userFacilityIdList.length>0 && this.userFacilityIdList!="0")
     {
      this.getServiceRequest()
     }
     else
     {
      this.Loding = true;
      this.facilityService.getUserLocationFacilities(this.userInfo.userName,(facilities:UserLocationFacility[])=>
      {
        let objUserFacilities:UserLocationFacility[]=facilities
        this.userFacilityIdList=objUserFacilities.map(x => x.FacilityMasterID).join(", ");
        this.getServiceRequest()
      });
     }
    //End:Added By Harikesh on 08-Sep-2020 for Defect#12154
    
    this.ServiceRequestcols = [
      { field: 'dateCreated', header: 'Request Date' },
      { field: 'dateServiceDue', header: 'Date Due' },
      { field: 'EquipmentSerialNumber', header: 'Serial #' },
      { field: 'equipmentTypeDescription', header: 'Equip Type'},
      { field: 'modelNumber', header: 'Model' },
      { field: 'facilityName', header: 'Loc. Name' },
      { field: 'facilityNumber', header: 'Loc. #' },
      { field: 'manufacturerName', header: 'Manufacturer' },
      { field: 'fullName', header: 'Created By' },
      { field: 'sqaDescription', header: 'SQA Desc' },
      { field: 'RequestDescription', header: 'Request Desc' },
      { field: 'TicketId', header: 'Ticket ID' },
      { field: 'EquipmentID', header: 'Equipment ID' }
    ];
    this.etcols = [
      { field: 'TicketNumber', header: 'Ticket #' },
      { field: 'DateServiceRequested', header: 'Requested' },
      { field: 'DateServicePerformed', header: 'Completed' },
      { field: 'FullName', header: 'Technician' },
      { field: 'Sqacode1', header: 'SQA' },
      { field: 'SqasubCode1', header: 'Sub SQA' }
    ]; 
    this.tpcols = [
      { field: 'manufacturerName', header: 'Manufacturer' },
      { field: 'PartNumber', header: 'Part #' },
      { field: 'partDescription', header: 'Description' },
      { field: 'RGANumber', header: 'RGA' },
      { field: 'Quantity', header: 'Qty.' },
      { field: 'UnitCost', header: 'Cost' }
    ]; 
   
    
} 
  public SearchSubmitKeyword()
  {
    this.ServiceRequestMangerData=[];
    this.selectedData=null;
    this.getServiceRequest();
  }
  
    public async getServiceRequest()
    {
        let getServiceRequestParam={
        GETSERVICEREQUEST:{
           serviceRequestId:null,
           WorkTypeID:null,
           sqaCodeId:null, 
           equipmentId:null,   
           facilityMasterIdList:null, 
           RequestStatusID:2, 
           returnTotalCount:0,
           returnAllRecords:1,
           maxRecords:200,   
           orderBy:"ServiceRequestID", 
           SearchTerm:''
         }
       }
      getServiceRequestParam.GETSERVICEREQUEST.SearchTerm=this.txtkeywordNg;
      getServiceRequestParam.GETSERVICEREQUEST.facilityMasterIdList=this.userFacilityIdList;
      let getServiceRequest = getServiceRequestParam.GETSERVICEREQUEST;
      this.Loding = true;
      await this._getServiceRequest.getServiceRequest(JSON.stringify({getServiceRequest})).subscribe((Result:any) =>{
      this.ServiceRequestMangerData=Result; 
      this.ServiceRequestMangerData.forEach(item => 
        {
         item.dateCreatedFmt = this.datePiepe.transform(item.dateCreated, "MM/dd/yyyy"),
         item.dateServiceDueFmt=this.datePiepe.transform(item.dateServiceDue, "MM/dd/yyyy")
        });    
      this.Loding = false;       
     },
     (respose: Response) => { 
      this.Loding = false;     
     });
    }

    selectServiceRequest(obj){
    
       var GETEQUIPMENTTICKETSParam = 
        {
          "GETEQUIPMENTTICKETS":
          {
            "equipmentId":obj.EquipmentID,
            "ticketStatusCode":"Complete"
         }       
        };
        this.getEquipmentTickets(GETEQUIPMENTTICKETSParam)
      }
    public getEquipmentTickets(GETEQUIPMENTTICKETSParam)
    {
  
     this.displaySRTicketDetail=false;
     this._getEquipmentTickets.getEquipmentTickets(JSON.stringify(GETEQUIPMENTTICKETSParam)).subscribe((Result:any) =>{
     var res=Result.tickets;
     this.equipmenttickets=res; 
     this.equipmenttickets=this.equipmenttickets.sort((a, b) => a.TicketId- b.TicketId);
       
     },
     (respose: Response) => { 
     
     });
    }

    voidServiceRequest() {
      this.displaySRConfirm = true;
    } 

      public async updatevoidServiceRequest(params1:any)
      {
        let serviceRequestId=this.selectedData.ServiceRequestID
        await this._getServiceRequest.voidServiceRequest(JSON.stringify(params1)).subscribe((response: any) => 
        {
          //this.getServiceRequest(); //Changed By Harikesh on 08-Sep-2020 for Defect#12154
          this.displaySRConfirm = false;
          this.voidServiceRequestReason = '';
          this.voidSRTicketSuccess = true;
          this.selectedData=null;
          this.ServiceRequestMangerData=this.ServiceRequestMangerData.filter(x=>x.ServiceRequestID!=serviceRequestId)
        });
    }

      SetServiceRequestTicketConfirm(params2:any){
      
      this._setServiceRequestTicket.setServiceRequestTicket(JSON.stringify(params2)).subscribe((Result: any) => {
      this.getServiceRequest();    
      });
     
    }

      getdispServiceRequestTicket(params3:any){
      
      this._getTicketsService.getTicketParts(JSON.stringify(params3)).subscribe((Result: any) => {
      this.getTicketPartsData=Result;
     
    },
    (respose: Response) => { 
    
    });
     
    }

    OkClose()  
    {    
      this.voidSRTicketSuccess = false;  
      this.selectedData=null; 
     
    }
    LinkOkClose()
    {
      this.setSRTicketSuccess=false;
      this.selectedData=null;
    }
  
   
    voidServiceRequestConfirm(obj) {
     
      if (this.voidServiceRequestReason != '') 
      {
        this.displayServiceRequestDetails=false;
        var params1 = 
        {
          "VOIDSERVICEREQUEST": 
          {           
            "ServiceRequestID":obj.ServiceRequestID,
            "TicketID":obj.TicketID,  
            "VoidReason":this.voidServiceRequestReason,
            "UserID":obj.ModifiedBy
          }         
        };
        this.updatevoidServiceRequest(params1);
        //Start:Commented by Harikesh on 08-Sep-2020 for Defect#12154
        //this.displaySRConfirm = false;
        //this.voidServiceRequestReason = '';
        //this.voidSRTicketSuccess = true;
        //this.getServiceRequest();
        //this.selectedData=null;
        //End:Commented by Harikesh on 08-Sep-2020 for Defect#12154
      }
      else 
      {
        
      }
    }
        dispServiceRequestTicket(obj) {
       
        this.displaySRTicketDetail = true;
        var params3 = 
          {
            "GETTICKETPARTS":
            {
              "TicketID":obj.TicketId
            }
          };
          this.getdispServiceRequestTicket(params3);         
        }

        setServiceRequestTicket() {
          this.displaySRTicketConfirm = true;
        } 
        setServiceRequestTicketConfirm(objSR, objT) {
        
          var params2 = 
            {
              "SETSERVICEREQUESTTICKET":
              {
                 "ServiceRequestID":objSR.ServiceRequestID,
                 "VoidReason":null,
                 "TicketID": objT.TicketId,
                 "UserID": objSR.ModifiedBy 
              }
            }; 
            this.SetServiceRequestTicketConfirm(params2);
            this.displaySRTicketConfirm = false;
            this.displaySRTicketDetail = false;
            this.setSRTicketSuccess = true;
            this.getServiceRequest();

          }
}
